<template>
  <ApolloMutation
    :mutation="(gql) => updateChapterNameQuery"
    :variables="{
      chapterId: iri,
      name: mutableName,
    }"
  >
    <template v-slot="{ mutate, loading }">
          <v-text-field
            hide-details
            outlined
            background-color="white"
            :loading="loading ? 'primaryAction' : false"
            @keydown="debouncedTextInput(mutate)"
            :placeholder="$t('chapter.chapterTitle')"
            dense
            v-model="mutableName"
          />
    </template>
  </ApolloMutation>
</template>
<script>
import { chapterQueries } from "@/graphql/ChapterQueries";
import debounce from "@/helpers/debounce";
const MAX_CHAPTER_NAME_CHARS = 60;
export default {
  props: {
    iri: String,
    name: String,
  },
  data() {
    return {
      mutableName: this.name,
    }
  },
  methods: {
    debouncedTextInput: debounce(function (mutate) {
      mutate()
    }, 500),
  },
  computed: {
    updateChapterNameQuery() {
      return chapterQueries.updateChapterName
    }
  },
  watch: {
    mutableName(newValue) {
      if (newValue.length > MAX_CHAPTER_NAME_CHARS) {
        this.mutableName = newValue.substring(0, MAX_CHAPTER_NAME_CHARS)
      }
    },
    name(newValue) {
      if (newValue != this.mutableName) {
        this.mutableName = newValue
      }
    },
  }
}
</script>

